import { useTranslation } from 'react-i18next';
import ModalProps from "@ltypes/modalProps";
import Modal from "@components/modals/Modal/Modal";
import './TutorialModal.scss';
import { useEffect, useState } from 'react';

type TutorialModalProps = {
    tutorialKey: string,
} & ModalProps;

function TutorialModal(props: TutorialModalProps) {

    const [steps, setSteps] = useState<Array<string>>([]);

    const { t } = useTranslation();

    useEffect(() => {
        if(props.tutorialKey == '') {
            return;
        }

        setSteps(t(`modal.tutorial.${props.tutorialKey}.steps`, { returnObjects: true }));
        console.log(t(`modal.tutorial.${props.tutorialKey}.steps`, { returnObjects: true }));
    }, [props.tutorialKey]);
    
    return (
        <Modal className="modal-tutorial" visible={props.visible} onHide={props.onHide}>
            <h2 className="text-center">{t(`modal.tutorial.${props.tutorialKey}.title`)}</h2>
            <div className="row mt-3">
                <ul>
                    {steps.map((step: string, index: number) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: step }}/>
                    ))}
                </ul>
            </div>
        </Modal>
    );
}

export default TutorialModal;
